import React from "react";

type HTMLContainerProps = React.HTMLAttributes<HTMLDivElement> & {
  html: React.ReactElement[] | string;
  component?: React.ElementType;
};

export default function HTMLContainer({
  component: Component = "div",
  html,
  ...props
}: HTMLContainerProps) {
  if (typeof html === "string") {
    return <Component {...props} dangerouslySetInnerHTML={{ __html: html }} />;
  }

  return <Component {...props}>{html}</Component>;
}
